import React, { useState, useEffect } from "react";
import ButtonMedium from '../components/Button-medium';
import { FaPlay, FaPause, FaBackward, FaForward, FaVolumeUp } from "react-icons/fa";
import '../css/MusicPlayer.css';

const MusicPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(0);
  const [volume, setVolume] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = React.useRef(null);

  const tracks = [
    { title: "Daydreaming", artist: "Victoria", url: "/assets/music/Daydreaming.mp3", cover: "/assets/images/daydreaming-cover.jpg" },
    { title: "Love Parade", artist: "Victoria", url: "/assets/music/LoveParade.mp3", cover: "/assets/images/loveparade-cover.jpg" },
    { title: "Sensitive", artist: "Victoria", url: "/assets/music/Sensitive.mp3", cover: "/assets/images/sensitive-cover.jpg" },
  ];

  useEffect(() => {
    const audio = audioRef.current;
    const setAudioData = () => {
      setDuration(audio.duration);
      setCurrentTime(audio.currentTime);
    };
    const setAudioTime = () => setCurrentTime(audio.currentTime);

    audio.addEventListener("loadeddata", setAudioData);
    audio.addEventListener("timeupdate", setAudioTime);

    return () => {
      audio.removeEventListener("loadeddata", setAudioData);
      audio.removeEventListener("timeupdate", setAudioTime);
    };
  }, []);

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  const skipTrack = (direction) => {
    if (direction === "forward") {
      setCurrentTrack((prev) => (prev + 1) % tracks.length);
    } else if (direction === "backward") {
      setCurrentTrack((prev) => (prev - 1 + tracks.length) % tracks.length);
    }
    setIsPlaying(false);
    setTimeout(() => {
      setIsPlaying(true);
      audioRef.current.play();
    }, 0);
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    audioRef.current.volume = newVolume;
  };

  const handleProgressChange = (e) => {
    const newTime = e.target.value;
    setCurrentTime(newTime);
    audioRef.current.currentTime = newTime;
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  // Calculate the time left in the song
  const timeLeft = duration - currentTime;

  return (
    <div className="music-player">
      <div className="track-info">
        <img src={tracks[currentTrack].cover} alt="Album Cover" className="album-cover" />
        <div className="track-details">
          <p className="track-title">{tracks[currentTrack].title}</p>
          <p className="track-artist">{tracks[currentTrack].artist}</p>
        </div>
      </div>
      <div className="controls-wrapper">
        <div className="controls">
          <ButtonMedium
            onClick={() => skipTrack("backward")}
            icon={() => <FaBackward />}
            className="control-button"
            label=""
            setIsButtonHovered={() => {}}
          />

          <ButtonMedium
            onClick={togglePlayPause}
            icon={() => (isPlaying ? <FaPause /> : <FaPlay />)}
            className="control-button"
            label=""
            setIsButtonHovered={() => {}}
          />

          <ButtonMedium
            onClick={() => skipTrack("forward")}
            icon={() => <FaForward />}
            className="control-button"
            label=""
            setIsButtonHovered={() => {}}
          />
        </div>
        <div className="progress-bar-container">
          <div className="time-display">
            <span>{formatTime(currentTime)}</span>
          </div>
          <input
            type="range"
            min="0"
            max={duration}
            value={currentTime}
            onChange={handleProgressChange}
            className="progress-bar"
          />
          <div className="time-display">
            <span>{formatTime(timeLeft)}</span> {/* Display time left */}
          </div>
        </div>
      </div>

      <div className="volume-control">
        <FaVolumeUp className="volume-icon" />
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleVolumeChange}
          className="volume-slider"
        />
      </div>

      <audio ref={audioRef} src={tracks[currentTrack].url}></audio>
    </div>
  );
};

export default MusicPlayer;